import styled from 'styled-components'

/** @deprecated Use an "aria-label" attribute instead */
const SrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`

export default SrOnly
